import { useEffect, useRef, useState } from 'react';

const ScrollFadeIn = ({ children, className = '', style = {} }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(entry.target);
        }
      },
      {
        threshold: 0.1,
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={`scroll-animate ${visible ? 'show' : ''} ${className}`}
      style={style}
    >
      {children}
    </div>
  );
};

export default ScrollFadeIn;
